export const ringConfig = {
    coefficients: {
        'low': {
            10: {
                blue: 0,
                gray: 0,
                green: 0,
            },
            20: {
                blue: 0,
                gray: 0,
                green: 0,
            },
            30: {
                blue: 0,
                gray: 0,
                green: 0,
            },
            40: {
                blue: 0,
                gray: 0,
                green: 0,
            },
            50: {
                blue: 0,
                gray: 0,
                green: 0,
            },
        },
        'medium': {
            10: {
                blue: 0,
                green: 0,
                gray: 0,
                yellow: 0,
                purple: 0,
            },
            20: {
                blue: 0,
                green: 0,
                gray: 0,
                yellow: 0,
                purple: 0,
            },
            30: {
                blue: 0,
                green: 0,
                gray: 0,
                yellow: 0,
                purple: 0,
                orange: 0,
            },
            40: {
                blue: 0,
                green: 0,
                gray: 0,
                yellow: 0,
                purple: 0,
            },
            50: {
                blue: 0,
                green: 0,
                yellow: 0,
                purple: 0,
                red: 0,
            },
        },
        'medium-high': {
            10: {
                blue: 0,
                yellow: 0,
                purple: 0,
            },
            20: {
                blue: 0,
                yellow: 0,
                purple: 0,
            },
            30: {
                blue: 0,
                green: 0,
                orange: 0,
            },
            40: {
                blue: 0,
                green: 0,
                orange: 0,
            },
            50: {
                blue: 0,
                yellow: 0,
                red: 0,
            },
        },
        'high': {
            10: {
                blue: 0,
                red: 0,
            },
            20: {
                blue: 0,
                red: 0,
            },
            30: {
                blue: 0,
                red: 0,
            },
            40: {
                blue: 0,
                red: 0,
            },
            50: {
                blue: 0,
                red: 0,
            },
        },
        // 'low': {
        //     10: {
        //         blue: 0,
        //         gray: 1.2,
        //         green: 1.5,
        //     },
        //     20: {
        //         blue: 0,
        //         gray: 1.2,
        //         green: 1.5,
        //     },
        //     30: {
        //         blue: 0,
        //         gray: 1.2,
        //         green: 1.5,
        //     },
        //     40: {
        //         blue: 0,
        //         gray: 1.2,
        //         green: 1.5,
        //     },
        //     50: {
        //         blue: 0,
        //         gray: 1.2,
        //         green: 1.5,
        //     },
        // },
        // 'medium': {
        //     10: {
        //         blue: 0,
        //         green: 1.5,
        //         gray: 1.9,
        //         yellow: 2,
        //         purple: 3,
        //     },
        //     20: {
        //         blue: 0,
        //         green: 1.5,
        //         gray: 1.8,
        //         yellow: 2,
        //         purple: 3,
        //     },
        //     30: {
        //         blue: 0,
        //         green: 1.5,
        //         gray: 1.7,
        //         yellow: 2,
        //         purple: 3,
        //         orange: 4,
        //     },
        //     40: {
        //         blue: 0,
        //         green: 1.5,
        //         gray: 1.6,
        //         yellow: 2,
        //         purple: 3,
        //     },
        //     50: {
        //         blue: 0,
        //         green: 1.5,
        //         yellow: 2,
        //         purple: 3,
        //         red: 5,
        //     },
        // },
        // 'medium-high': {
        //     10: {
        //         blue: 0,
        //         yellow: 2.45,
        //         purple: 5,
        //     },
        //     20: {
        //         blue: 0,
        //         yellow: 2.45,
        //         purple: 5,
        //     },
        //     30: {
        //         blue: 0,
        //         green: 1.38,
        //         orange: 10.02,
        //     },
        //     40: {
        //         blue: 0,
        //         green: 1.94,
        //         orange: 10.1,
        //     },
        //     50: {
        //         blue: 0,
        //         yellow: 2.46,
        //         red: 15.06,
        //     },
        // },
        // 'high': {
        //     10: {
        //         blue: 0,
        //         red: 9.9,
        //     },
        //     20: {
        //         blue: 0,
        //         red: 19.8,
        //     },
        //     30: {
        //         blue: 0,
        //         red: 29.7,
        //     },
        //     40: {
        //         blue: 0,
        //         red: 39.6,
        //     },
        //     50: {
        //         blue: 0,
        //         red: 49.5,
        //     },
        // },
    },
    weights: {
        'low': {
            10: ['green', 'gray', 'gray', 'gray', 'blue', 'gray', 'gray', 'gray', 'gray', 'blue'],
            20: [
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
            ],
            30: [
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
            ],
            40: [
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
            ],
            50: [
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
                'green',
                'gray',
                'gray',
                'gray',
                'blue',
                'gray',
                'gray',
                'gray',
                'gray',
                'blue',
            ],
        },
        'medium': {
            10: [
                'blue',
                'gray',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
            ],
            20: [
                'green',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'gray',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
            ],
            30: [
                'green',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'gray',
                'blue',
                'orange',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
            ],
            40: [
                'yellow',
                'blue',
                'purple',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'gray',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
            ],
            50: [
                'yellow',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'purple',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
                'green',
                'blue',
                'red',
                'blue',
                'green',
                'blue',
                'yellow',
                'blue',
                'green',
                'blue',
            ],
        },
        'medium-high': {
            10: [
                'purple',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'blue',
                'blue',
                'blue',
            ],
            20: [
                'blue',
                'blue',
                'blue',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'purple',
                'blue',
                'blue',
                'blue',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'purple',
            ],
            30: [
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'orange',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'orange',
                'green',
                'blue',
                'blue',
                'green',
            ],
            40: [
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'blue',
                'green',
                'orange',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'blue',
                'green',
                'orange',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'blue',
                'blue',
                'green',
                'blue',
                'green',
            ],
            50: [
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'red',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
                'blue',
                'blue',
                'blue',
                'blue',
                'yellow',
                'yellow',
            ],
        },
        'high': {
            10: ['blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'red'],
            20: [
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'red',
            ],
            30: [
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'red',
            ],
            40: [
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'red',
            ],
            50: [
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'blue',
                'red',
            ],
        },
    },
};

export const colors = {
    blue: '4F6DA8',
    gray: 'C8CFE2',
    green: '1BDB3A',
    yellow: 'FFDA19',
    purple: 'C625FF',
    orange: 'FF881B',
    red: 'ED1D49',
};

export const ringRulesData = [
    {
        content1: 'GameRing.ringRule1',
        constent2: '',
        img: null,
    }
];
